module.exports = "::ng-deep .search-body-content.px-2{\n    height: 20rem !important;\n}\n"